import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PaymentModal from '../../components/common/PaymentModal';

const PricingPage = ({ view = 'operations', refreshUser }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userSubscriptions = []; // TODO: Get this from your auth context/state

  const handleClose = () => {
    // Navigate back to previous page or home
    if (location.state?.from) {
      navigate(location.state.from);
    } else {
      navigate('/');
    }
  };

  return (
    <PaymentModal 
      isOpen={true}
      onClose={handleClose}
      userSubscriptions={userSubscriptions}
      view={view}
      refreshUser={refreshUser}
    />
  );
};

export default PricingPage; 